import { render, staticRenderFns } from "./c3.vue?vue&type=template&id=8624842e"
import script from "./c3.vue?vue&type=script&lang=js"
export * from "./c3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports